"use strict";
import {
    Checkbox,
    FormControlLabel,
    Grid,
    MenuItem,
    Select,
    Typography,
    Button,
    Tooltip,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    CircularProgress,
    Box,
    Stack,
    IconButton
} from "@mui/material";
import React, {
    useEffect,
    useState,
    useCallback,
    useRef,
    useContext,
    useMemo,
} from "react";
import classes from "../../Assets/Styles/Transcriber.module.css";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ContactsIcon from "@mui/icons-material/Contacts";
import GroupsIcon from "@mui/icons-material/Groups";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import Loader from "../../Components/Loader";
import axios from "axios";
import { Store } from "../../Store";
import {
  ADD_SPEECH_FOR_PROJECT,
  AUDIO_CHOPPING_STATUS_CHECK,
  AddUpdateDelete_CHARACTER_FOR_PROJECT,
  // CREATE_ALL_VOCALS_AUTOMATICALLY,
  // CREATE_LIST_AUDIOS_TEXTS,
  DELETE_SPEECH_FOR_PROJECT,
  GET_CHARACTERS_FOR_PROJECT,
  GET_SPEECH_FOR_PROJECT_BY_PAGE,
  UPDATE_ONE_SPEECH,
  // VOICE_TRAINING,
  VOICE_TRAINING_STATUS_CHECK,
  AUTOMATIC_VOICE_PROCESSING,
  VALIDATE_EMOTIONS,
  GET_SPEECH_POSITION_AROUND_TIME,
  SOFT_DELETE_CHARACTER,
  APPEND_CHARACTER,
  Assign_Character_To_All_Dialogues,
  GET_SPEECHS_DETAILS_FOR_PROJECT,
  SEARCH_SPEECH_FOR_PROJECT,
  CHARACTER_STATUSES_URL,
  EVALUATE_ALL_VOICES,
} from "../../ApiEndpoints";
import { ToastContainer, toast } from "react-toastify";
import UnifiedVideoPlayer from "../../Components/Players/UnifiedVideoPlayer";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import { useMediaQuery } from "@mui/material";
import joinBelow from "../../Assets/Images/joinBelow.png";
import {
  formatInputs,
  formatTime,
  timeStringToSeconds,
} from "../../utils/generalFunctions";
import SoundEffectsParts from "../../Components/TranscriberComponents/SoundEffectsParts";
import { primaryColor, secondaryColor } from "../../utils/constants";
import TaskButton from "../../Components/Buttons/TaskButton";
import WarningToastWithOverlay from "../../Components/WarningToastWithOverlay/index.js";
import CharacterInput from "../../Components/CharacterSearch.js";
import {
  AVAILABLE_RATINGS,
  CHARACTER_GOOD_READY_DIALOGUES,
  CHARACTER_MINIMUM_READY_DIALOGUES,
  DEFAULT_EMOTIONS,
} from "../../Data/dialogueCodes";

import DialogueSearchFilter, {
  DEFAULT_DIALOGUE_SEARCH_FILTERS,
  hasAnyDialogueSearchFilter,
} from "../../Components/DialogueSearchFilter/DialogueSearchFilter";



const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    width: "0px",
    // height: "20px",
    borderRadius: "var(--radius-md)",
    position: "relative",
    backgroundColor: "none",
    border: "none",
    fontSize: "var(--font-size-normal)",
    padding: "6px 20px 6px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    color: `${secondaryColor}`,
    // "&:focus": {
    //   borderRadius: 4,
    //   borderColor: "#80bdff",
    //   boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    // },
  },
}));

const BootstrapInputForAvalialbe = styled(InputBase)(({ theme }) => ({
  "& .MuiInputBase-input": {
    color: `${secondaryColor}`,
    width: "110px",
    position: "relative",
    backgroundColor: "none",
    border: "none",
    fontSize: "var(--font-size-normal)",
  },
}));

/**
 * Normalizes rating values received from the API into the dropdown friendly format.
 * Converts invalid, empty, or non-positive inputs into an empty string so the UI renders a blank state.
 */
const normalizeOriginalAudioRating = (rawValue) => {
    if (rawValue === null || rawValue === undefined) {
        return "";
    }

    const numericValue = Number(rawValue);

    if (!Number.isFinite(numericValue) || numericValue <= 0) {
        return "";
    }

    return String(numericValue);
};

/**
 * Translates dropdown selections back into a sanitized numeric rating for persistence.
 * Coerces empty selections or non-positive values into null to avoid saving unintended ratings.
 */
const parseDropdownRatingValue = (value) => {
    if (value === null || value === undefined || value === "") {
        return null;
    }

    const numericValue = Number(value);

    if (!Number.isFinite(numericValue) || numericValue <= 0) {
        return null;
    }

    return numericValue;
};

const TranscriberScreen = () => {
  const timeoutIdRef = useRef(null);
  const screenIsOver1200px = useMediaQuery("(min-width: 1200px)");
  const { state } = useContext(Store);
  const { projectFile, userInfo } = state;
  const [audioData, setAudioData] = useState([]);
    const [openCharactersFolder, setOpenCharactersFolder] = useState(true);
    // Maintain direct references to every character name input so we can restore focus later.
    const characterNameInputRefs = useRef({});
    const characterListContainerRef = useRef(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [seekTime, setSeekTime] = useState(0);
  const [seekTimeIndex, setSeekTimeIndex] = useState(0);
  const [scrollableItem, setScrollableItem] = useState(0);
  const [scrollableItemLastUpdated, setScrollableItemLastUpdated] = useState(0);
  const [pausePlay, setPausePlay] = useState(false);
  const [audioLoader, setAudioLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  const [startTimeText, setStartTimeText] = useState("00:00:00");
    const [endTimeText, setEndTimeText] = useState("00:00:00");
    const [speakerText, setSpeakerText] = useState("");
    const [diaText, setDiaText] = useState("");
    const [audioEmotion, setAudioEmotion] = useState("neutral");
    const [audioRating, setAudioRating] = useState("");
    const [videoSource, setVidoSource] = useState(projectFile.videoUrl);
    const audioSource = projectFile.dialogueAudioUrl;
    const numberOfDialogues = projectFile.numberOfDialogues;

    const originalLanguageCode = projectFile.orginalLang || "";

    // Update video source when the project changes
    useEffect(() => {
        setVidoSource(projectFile.videoUrl);
    }, [projectFile.videoUrl]);

    const [workPlaceType, setWorkPlaceType] = useState(true);
    const [characters, setCharacters] = useState([]);
    // Track whether automatic resorting is enabled so we can pause it during inline edits.
    const [shouldResortCharacters, setShouldResortCharacters] = useState(true);
    // Incremented whenever a sort is committed to force downstream effects to observe the change.
    const [characterSortCommitCount, setCharacterSortCommitCount] = useState(0);
    const lastSortedOrderRef = useRef([]);
    // Remember which speaker was most recently focused so we can restore visibility after sorting.
    const mostRecentlyFocusedSpeakerRef = useRef(null);
    const pendingScrollSpeakerRef = useRef(null);
    const shouldRestoreFocusRef = useRef(false);
    // Derive a stable character ordering that only re-sorts when edits are committed.
    const sortedCharacters = useMemo(() => {
        const charactersBySpeaker = new Map(
            characters.map((char) => [char.speaker, char])
        );

        if (!shouldResortCharacters) {
            // Preserve the previous ordering when sorting is suspended so fields stay put while editing.
            const preservedOrder = lastSortedOrderRef.current || [];
            const orderedCharacters = [];
            const nextOrder = [];

            preservedOrder.forEach((speaker) => {
                const matchingCharacter = charactersBySpeaker.get(speaker);
                if (matchingCharacter) {
                    orderedCharacters.push(matchingCharacter);
                    nextOrder.push(speaker);
                    charactersBySpeaker.delete(speaker);
                }
            });

            charactersBySpeaker.forEach((character, speaker) => {
                orderedCharacters.push(character);
                nextOrder.push(speaker);
            });

            lastSortedOrderRef.current = nextOrder;
            return orderedCharacters;
        }

        const sorted = [...characters].sort((a, b) => {
            const nameA = a.displayName || a.speaker;
            const nameB = b.displayName || b.speaker;
            return nameA.localeCompare(nameB);
        });

        lastSortedOrderRef.current = sorted.map((character) => character.speaker);
        return sorted;
    }, [characters, shouldResortCharacters]);
    // Pause resorting so the characters list stays stable while the user types.
    const suspendCharacterSorting = useCallback(() => {
        setShouldResortCharacters((current) => {
            if (current) {
                return false;
            }

            return current;
        });
    }, []);
    // Resume resorting and optionally request focus restoration when the edit is committed.
    const commitCharacterSort = useCallback(
        (speaker, options = {}) => {
            const { restoreFocus = false } = options;
            const targetSpeaker = speaker || mostRecentlyFocusedSpeakerRef.current;

            if (!targetSpeaker) {
                shouldRestoreFocusRef.current = false;
                return;
            }

            pendingScrollSpeakerRef.current = targetSpeaker;
            mostRecentlyFocusedSpeakerRef.current = targetSpeaker;
            shouldRestoreFocusRef.current = restoreFocus;

            setShouldResortCharacters(true);
            setCharacterSortCommitCount((count) => count + 1);
        },
        []
    );
    // Remember the active speaker and freeze sorting once an input gains focus.
    const handleCharacterNameFocus = useCallback(
        (speaker) => {
            mostRecentlyFocusedSpeakerRef.current = speaker;
            suspendCharacterSorting();
        },
        [suspendCharacterSorting]
    );
    // Commit the new ordering once the field blurs.
    const handleCharacterNameBlur = useCallback(
        (speaker) => {
            commitCharacterSort(speaker, { restoreFocus: false });
        },
        [commitCharacterSort]
    );
    // Allow pressing Enter to commit immediately; otherwise keep sorting paused while typing.
    const handleCharacterNameKeyDown = useCallback(
        (event, speaker) => {
            if (event.key === "Enter" && !event.shiftKey) {
                event.preventDefault();
                commitCharacterSort(speaker, { restoreFocus: true });
                return;
            }

            suspendCharacterSorting();
        },
        [commitCharacterSort, suspendCharacterSorting]
    );
    const [, setCheckChoppingStatus] = useState(false);

  // pagination items
  const [pageButtonActivity, setPageButtonActivity] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageInput, setPageInput] = useState("1");
  const itemsPerPage = 10;
  const [dialogueSearchFilters, setDialogueSearchFilters] = useState(() => ({
    ...DEFAULT_DIALOGUE_SEARCH_FILTERS,
    searchIn: projectFile.orginalLang || "all",
    hasTranslatedAudio: "",
  }));

  const [isDialogueSearchActive, setIsDialogueSearchActive] = useState(false);
  const [searchResultCount, setSearchResultCount] = useState(0);

  const activeDialogueCount = isDialogueSearchActive
    ? searchResultCount
    : numberOfDialogues;

  const totalPages = Math.ceil(activeDialogueCount / itemsPerPage);
  const [warningShown, setWarningShown] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [subtitleOnlyMap, setSubtitleOnlyMap] = useState({});
  const [transcriptionStats, setTranscriptionStats] = useState(null);
  const [statsLoading, setStatsLoading] = useState(false);
  const [statsExpanded, setStatsExpanded] = useState(true);

    const containerRef = useRef(null);

    // Programmatically reveal, scroll to, and focus a character name input when requested.
    const focusCharacterNameField = useCallback(
        (speaker) => {
            if (!speaker) {
                return;
            }

            const scrollAndFocus = () => {
                const inputElement = characterNameInputRefs.current[speaker];

                if (inputElement) {
                    // Scroll the newly sorted input back into view and restore focus for continuity.
                    inputElement.focus();
                    inputElement.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                        inline: "nearest",
                    });
                }
            };

            if (!openCharactersFolder) {
                setOpenCharactersFolder(true);
                setTimeout(scrollAndFocus, 0);
                return;
            }

            scrollAndFocus();
        },
        [openCharactersFolder]
    );

    // Capture Alt+click on the speaker dropdown to jump to the matching character name field instead.
    const handleCharacterSelectMouseDown = useCallback(
        (event, speaker) => {
            if (event.altKey) {
                event.preventDefault();
                event.stopPropagation();
                focusCharacterNameField(speaker);
                return;
            }

            event.stopPropagation();
        },
        [focusCharacterNameField]
    );

    // Prevent the click event from bubbling when the dropdown does open normally.
    const handleCharacterSelectClick = useCallback((event) => {
        event.stopPropagation();
    }, []);

    // Prune stale refs when characters are removed so focus calls stay accurate.
    useEffect(() => {
        const refs = characterNameInputRefs.current;
        const activeSpeakers = new Set(sortedCharacters.map((char) => char.speaker));

        Object.keys(refs).forEach((speaker) => {
            if (!activeSpeakers.has(speaker)) {
                delete refs[speaker];
            }
        });
    }, [sortedCharacters]);

  const originalAudioEmotionOptions = useMemo(() => {
    const emotionsFromLoadedDialogues = audioData
      .map((dialogue) => dialogue?.originalAudioEmotion)
      .filter(Boolean);

    return [
      ...new Set([
        ...DEFAULT_EMOTIONS,
        ...emotionsFromLoadedDialogues,
      ]),
    ];
  }, [audioData]);

  useEffect(() => {
    setPageInput(String(pageNumber));
  }, [pageNumber]);

  const fetchTranscriptionStats = useCallback(async () => {
    if (!projectFile?.id) {
      return;
    }

    setStatsLoading(true);

    try {
      const response = await axios.post(GET_SPEECHS_DETAILS_FOR_PROJECT, {
        projectId: projectFile.id,
      });

      setTranscriptionStats(response.data);
    } catch (error) {
      console.log(error);
      toast.error("Error loading transcription progress");
    } finally {
      setStatsLoading(false);
    }
  }, [projectFile?.id]);

  useEffect(() => {
    if (pausePlay && screenIsOver1200px && workPlaceType) {
      scrollToItem(scrollableItem - 1);
    }
  }, [pausePlay, screenIsOver1200px, workPlaceType, scrollableItem]);

  const checkTimeInRange = useCallback(
    (time) => {
      if (!audioData) {
        return;
      }

      const itemInTimeRange = audioData.find(
        (item) => time >= item.start && time < item.end
      );

      if (itemInTimeRange && itemInTimeRange.id !== scrollableItemLastUpdated) {
        setScrollableItemLastUpdated(itemInTimeRange.id);
        setScrollableItem(itemInTimeRange.id);
      }
    },
    [audioData, scrollableItemLastUpdated]
  );

  useEffect(() => {
    checkTimeInRange(currentTime);
  }, [currentTime, checkTimeInRange]);

  useEffect(() => {
    fetchTranscriptionStats();
  }, [fetchTranscriptionStats]);

    useEffect(() => {
        if (characterSortCommitCount === 0) {
            return;
        }

        const targetSpeaker =
            pendingScrollSpeakerRef.current || mostRecentlyFocusedSpeakerRef.current;

        if (!targetSpeaker) {
            shouldRestoreFocusRef.current = false;
            pendingScrollSpeakerRef.current = null;
            return;
        }

        const inputElement = characterNameInputRefs.current[targetSpeaker];

        if (!inputElement) {
            shouldRestoreFocusRef.current = false;
            pendingScrollSpeakerRef.current = null;
            return;
        }

        const scrollElementIntoView = () => {
            const container = characterListContainerRef.current;

            if (container && container.contains(inputElement)) {
                const containerRect = container.getBoundingClientRect();
                const elementRect = inputElement.getBoundingClientRect();

                if (
                    elementRect.top < containerRect.top ||
                    elementRect.bottom > containerRect.bottom
                ) {
                    inputElement.scrollIntoView({
                        block: "nearest",
                        inline: "nearest",
                        behavior: "smooth",
                    });
                }

                return;
            }

            inputElement.scrollIntoView({
                block: "nearest",
                inline: "nearest",
                behavior: "smooth",
            });
        };

        const shouldRestoreFocus = shouldRestoreFocusRef.current;

        window.requestAnimationFrame(() => {
            if (
                shouldRestoreFocus &&
                document.activeElement !== inputElement &&
                typeof inputElement.focus === "function"
            ) {
                inputElement.focus({ preventScroll: true });
            }

            scrollElementIntoView();

            if (shouldRestoreFocus) {
                suspendCharacterSorting();
            }

            shouldRestoreFocusRef.current = false;
            pendingScrollSpeakerRef.current = null;
        });
    }, [
        characterSortCommitCount,
        sortedCharacters,
        suspendCharacterSorting,
    ]);

  const [characterVoiceStatus, setCharacterVoiceStatus] = useState({});
  // const [characterVoiceStatusLoading, setCharacterVoiceStatusLoading] = useState(false);

  useEffect(() => {
      let isMounted = true;

      const fetchCharacterStatuses = async () => {
          if (!projectFile.id) return;

          // setCharacterVoiceStatusLoading(true);

          try {
              const response = await axios.post(CHARACTER_STATUSES_URL, {
                  projectId: projectFile.id,
              });

              if (!isMounted) return;

              if (response.data?.status === true) {
                  setCharacterVoiceStatus(response.data.voiceStatus || {});
              } else {
                  setCharacterVoiceStatus({});
              }
          } catch (error) {
              console.error("Failed to fetch character voice statuses:", error);

              if (isMounted) {
                  setCharacterVoiceStatus({});
              }
          } finally {
              if (isMounted) {
                  // setCharacterVoiceStatusLoading(false);
              }
          }
      };

      fetchCharacterStatuses();

      return () => {
          isMounted = false;
      };
  }, [projectFile.id]);

  const scrollToItem = (index) => {
    const targetIndex = index;

    if (targetIndex < 0) {
      return;
    }
    const container = containerRef.current;

    if (!container) {
      return;
    }

    const item = container.children[targetIndex];

    if (!item) {
      return;
    }

    // Scroll only the dialogue container so the viewport position stays fixed.
    const containerRect = container.getBoundingClientRect();
    const itemRect = item.getBoundingClientRect();
    const offsetWithinContainer = itemRect.top - containerRect.top;
    const desiredScrollTop =
      container.scrollTop +
      offsetWithinContainer -
      (container.clientHeight - item.clientHeight) / 2;
    const maxScrollTop = Math.max(0, container.scrollHeight - container.clientHeight);
    const clampedScrollTop = Math.min(
      Math.max(0, desiredScrollTop),
      maxScrollTop
    );

    container.scrollTo({
      top: clampedScrollTop,
      behavior: "smooth",
    });
  };

  const displayAudioTime = useCallback((data) => {
    setCurrentTime(data);
  }, []);

  function findDisplayName(speaker) {
    const result = characters.find((char) => char.speaker === speaker);

    if (result.displayName) {
      return result.displayName;
    }
    return speaker;
  }

  //+ Text api for dialogue
  function handleTextChange(e, index) {
    const updatedData = [...audioData];
    updatedData[index] = {
      ...updatedData[index],
      text: e.target.value,
    };

    setAudioData(updatedData);
    clearTimeout(timeoutIdRef.current);

    timeoutIdRef.current = setTimeout(async () => {
      await axios.post(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: updatedData[index],
      });
    }, 1650);
  }
  //+ Speaker api for dialogue
  const handleSpeakerChange = async (e, index) => {
    const updatedData = [...audioData];
    updatedData[index] = {
      ...updatedData[index],
      speaker: e.target.value,
    };

    setAudioData(updatedData);

    try {
      const response = await axios.post(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: updatedData[index],
      });
      if (response.data) {
        setAudioData(updatedData);
      }
    } catch (err) {
      console.log(err);
      toast.error("Error in changing the speaker");
    }
  };


  //+ Start time api for dialogue
  function handleStartTimeChange(e, index) {
    const newTime = timeStringToSeconds(e.target.value);
    if (!newTime) {
      return;
    }
    const updatedData = [...audioData];
    updatedData[index] = {
      ...updatedData[index],
      start: newTime,
    };

    setAudioData(updatedData);
    clearTimeout(timeoutIdRef.current);

    timeoutIdRef.current = setTimeout(async () => {
      await axios.post(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: updatedData[index],
      });
    }, 2300);
  }
  //+ End time api for dialogue
  function handleEndTimeChange(e, index) {
    const newTime = timeStringToSeconds(e.target.value);
    if (!newTime) {
      return;
    }

    const updatedData = [...audioData];
    updatedData[index] = {
      ...updatedData[index],
      end: newTime,
    };

    setAudioData(updatedData);
    clearTimeout(timeoutIdRef.current);

    timeoutIdRef.current = setTimeout(async () => {
      await axios.post(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: updatedData[index],
      });
    }, 2300);
  }

  //+ face api for dialogue
  const handleFaceCheck = async (index) => {
    const updatedData = [...audioData];
    updatedData[index] = {
      ...updatedData[index],
      faceCheck: !updatedData[index].faceCheck,
    };

    setAudioData(updatedData);

    try {
      const response = await axios.post(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: updatedData[index],
      });
      if (response.data) {
        setAudioData(updatedData);
      }
    } catch (err) {
      console.log(err);
      toast.error("Error in checking/unchecking the face box");
    }
  };
  //+ emotion api for dialogue
  const handleDialogueEmotion = async (e, index) => {
    const updatedData = [...audioData];
    updatedData[index] = {
      ...updatedData[index],
      originalAudioEmotion: e.target.value,
    };

    setAudioData(updatedData);

    try {
      const response = await axios.post(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: updatedData[index],
      });
      if (response.data) {
        setAudioData(updatedData);
        await fetchTranscriptionStats();
      }
    } catch (err) {
      console.log(err);
      toast.error("Error in changing the dialogues's emotion");
    }
  };

  //+ rating api for dialogue
  const handleDialogueRating = async (e, index) => {
    const ratingValue = parseDropdownRatingValue(e.target.value);
    const updatedData = [...audioData];
    updatedData[index] = {
      ...updatedData[index],
      originalAudioRating: ratingValue,
    };

    setAudioData(updatedData);

    try {
      const response = await axios.post(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: updatedData[index],
      });
      if (response.data) {
        setAudioData(updatedData);
        await fetchTranscriptionStats();
      }
    } catch (err) {
      console.log(err);
      toast.error("Error in changing the dialogues's rating");
    }
  };

  //+ editing api for character
  const editCharacter = useCallback(
    (name, speaker) => {
      setCharacters((prevCharacters) => {
        if (!prevCharacters?.length) {
          return prevCharacters;
        }

        const updatedCharacters = prevCharacters.map((character) =>
          character.speaker === speaker
            ? {
                ...character,
                displayName: name,
              }
            : character
        );

        clearTimeout(timeoutIdRef.current);

        timeoutIdRef.current = setTimeout(async () => {
          try {
            await axios.post(AddUpdateDelete_CHARACTER_FOR_PROJECT, {
              projectId: projectFile.id,
              characters: updatedCharacters,
            });
          } catch (error) {
            console.error("Error updating characters", error);
            toast.error("Error updating character name");
          }
        }, 1650);

        return updatedCharacters;
      });
    },
    [projectFile.id]
  );

  const handleCharacterNameChange = useCallback(
    (speaker, value) => {
      suspendCharacterSorting();
      editCharacter(formatInputs(value), speaker);
    },
    [editCharacter, suspendCharacterSorting]
  );

  //+ adding api for char
  const removeCharacter = async (speaker, isImported) => {
    const character = characters.find(char => char.speaker === speaker);
    if (!character) return;

    const displayName = character.displayName || character.speaker;
    const confirmationText = `Removing character "${displayName}". Are you sure?`

    // Create a custom toast ID to prevent duplicate toasts
    const TOAST_ID = `delete-character-${speaker}`;

    // If the same toast is already active, don't show another one
    if (toast.isActive(TOAST_ID)) return;

    // Show a confirmation toast with action buttons
    toast(
      <div>
        <p>{confirmationText}</p>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px', gap: '8px' }}>
          <Button
            size="small"
            onClick={() => toast.dismiss(TOAST_ID)}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            size="small"
            variant="contained"
            color="error"
            onClick={async () => {
              toast.dismiss(TOAST_ID);
              try {
                const response = await axios.post(SOFT_DELETE_CHARACTER, {
                  projectId: projectFile.id,
                  speaker
                });

                if (response.data.success) {
                  // Update local state with the fresh array from the server:
                  setCharacters(response.data.characters);

                  toast.success(
                    isImported
                      ? "The imported character has been removed"
                      : "The character has been removed"
                  );

                  fetchCharacters();
                }
              } catch (err) {
                console.error("Error soft-deleting character:", err);
                toast.error(
                  isImported
                    ? "Error marking imported character as unused"
                    : "Error marking character as unused"
                );
              }
            }}
          >
            Yes
          </Button>
        </div>
      </div>,
      {
        toastId: TOAST_ID,
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        closeButton: false,
        position: "top-center",
        style: {
          minWidth: '300px',
          maxWidth: '400px'
        }
      }
    );
  };

  //+ adding api
  const AddNewDialogue = async () => {
    if (endTimeText === "00:00:00") {
      toast.error("Enter The Ending time for this sentence");
      return;
    }

    let updatedData = [...audioData];

    const sanitizedRating = parseDropdownRatingValue(audioRating);

    const translations = [];
    projectFile.finalLang?.forEach((langCode) => {
      translations.push({
        languageCode: langCode,
        translatedText: "",
        translatedAudioList: [],
        translatedAudio: "",
        translatedAudioRating: "",
        translatedAudioNote: null,
        translatedAudioPath: null,
        translatedRecording: "",
      });
    });

    try {
      const response = await axios.post(ADD_SPEECH_FOR_PROJECT, {
        projectId: projectFile.id,
        dialogue: {
          speaker: speakerText,
          text: diaText,
          end: timeStringToSeconds(endTimeText),
          start: timeStringToSeconds(startTimeText),
          originalAudioEmotion: audioEmotion,
          originalAudioRating: sanitizedRating,
        },
      });
      if (response.data) {
        const NewDialogue = {
          speaker: speakerText,
          text: diaText,
          end: timeStringToSeconds(endTimeText),
          start: timeStringToSeconds(startTimeText),
          dbid: response.data,
          translations: translations,
          originalAudioEmotion: audioEmotion,
          originalAudioRating: sanitizedRating,
        };

        const index = updatedData.findIndex(
          (obj) =>
            NewDialogue.start < obj.start ||
            (NewDialogue.start === obj.start && NewDialogue.end < obj.end)
        );

        if (index === -1) {
          updatedData.push(NewDialogue);
        } else {
          updatedData.splice(index, 0, NewDialogue); // Insert at the found index
        }

        // updatedData.push(NewDialogue);

        updatedData = updatedData.map((object, index) => ({
          ...object,
          add: false,
          id: index,
        }));

        toast.success("A new dialogue has been added");

        setStartTimeText("00:00:00");
        setEndTimeText("00:00:00");
        setSpeakerText("");
        setDiaText("Write here");
        setAudioEmotion("neutral");
        setAudioRating("");

        setAudioData(updatedData);
      }
    } catch (err) {
      console.log(err);
      toast.error("Error in adding the new dialogue");
    }
  };

  //+ Merging api
  const MergeDialogues = async (index) => {
    setAudioLoader(true);
    let updatedData = [...audioData];

    if (updatedData[index].speaker !== updatedData[index + 1].speaker) {
      toast.error("Make sure both of dialogues have same character");
      setAudioLoader(false);
      return;
    }

    // Merge translations
    const mergeTranslations = (t1, t2) => {
      return {
        ...t1,
        translatedText: t1.translatedText + " " + t2.translatedText,
        translatedAudioDuration:
          (t1.translatedAudioDuration || 0) + (t2.translatedAudioDuration || 0),
      };
    };

    // Merge translations
    const mergedTranslations = updatedData[index].translations.map((t1) => {
      const matchingT2 = updatedData[index + 1].translations.find(
        (t2) => t2.languageCode === t1.languageCode
      );
      return matchingT2 ? mergeTranslations(t1, matchingT2) : t1;
    });

    // Add any translations from the second dialogue that weren't in the first
    updatedData[index + 1].translations.forEach((t2) => {
      if (!mergedTranslations.some((t) => t.languageCode === t2.languageCode)) {
        mergedTranslations.push(t2);
      }
    });

    const NewDialogue = {
      speaker: updatedData[index].speaker,
      text: updatedData[index].text + " " + updatedData[index + 1].text,
      end: updatedData[index + 1].end,
      start: updatedData[index].start,
      faceCheck: updatedData[index].faceCheck,
      originalAudioEmotion: updatedData[index].originalAudioEmotion,
      originalAudioRating: updatedData[index].originalAudioRating,
      keepOriginalText: updatedData[index].keepOriginalText
        ? updatedData[index].keepOriginalText
        : false,
      finalNote: updatedData[index].finalNote
        ? updatedData[index].finalNote
        : null,
      creationDate: updatedData[index].creationDate
        ? updatedData[index].creationDate
        : null,
      translations: mergedTranslations,
    };

    try {
      const response = await axios.post(ADD_SPEECH_FOR_PROJECT, {
        projectId: projectFile.id,
        dialogue: NewDialogue,
      });
      NewDialogue.dbid = response.data;
      if (response.data) {
        await axios.post(DELETE_SPEECH_FOR_PROJECT, {
          projectId: projectFile.id,
          uid: updatedData[index].dbid,
        });
        await axios.post(DELETE_SPEECH_FOR_PROJECT, {
          projectId: projectFile.id,
          uid: updatedData[index + 1].dbid,
        });

        const indexNumber = updatedData.findIndex(
          (obj) =>
            NewDialogue.start < obj.start ||
            (NewDialogue.start === obj.start && NewDialogue.end < obj.end)
        );

        updatedData = updatedData.filter(
          (dia) =>
            dia.dbid !== updatedData[index].dbid &&
            dia.dbid !== updatedData[index + 1].dbid
        );

        if (indexNumber === -1) {
          updatedData.push(NewDialogue);
        } else {
          updatedData.splice(indexNumber, 0, NewDialogue); // Insert at the found indexNumber
        }

        updatedData = updatedData.sort((a, b) => {
          if (a.start < b.start) return -1;
          if (a.start > b.start) return 1;
          if (a.end < b.end) return -1;
          if (a.end > b.end) return 1;

          return 0;
        });

        updatedData = updatedData.map((object, index) => ({
          ...object,
          id: index,
        }));

        setAudioData(updatedData);
        setAudioLoader(false);
        toast.success("Dialogues has been merged");
      }
    } catch (err) {
      console.log(err);
      toast.error("Error in adding the new dialogue");
      setAudioLoader(false);
    }
  };

  //+ delete api
  const removeDialogue = async (uid) => {
    const confirmed = window.confirm("Are you sure you want to delete this dialogue?");
    if (!confirmed) {
        return;
    }
    try {
        const response = await axios.post(DELETE_SPEECH_FOR_PROJECT, {
            projectId: projectFile.id,
            uid: uid,
        });

        if (response.data) {
            let newItems = audioData.filter((dia) => dia.dbid !== uid);
            newItems = newItems.map((object, index) => ({
                ...object,
                id: index,
            }));
            setAudioData(newItems);

            toast.success("The dialogue has been deleted!");
        }
    } catch (err) {
        console.log(err);
        toast.error("Error in deleting the dialogue");
    }
  };

  const getCharacterEmotionVoice = (speaker, emotion) => {
      return characterVoiceStatus?.[speaker]?.emotions?.[emotion] || null;
  };

  const getCharacterEmotionVoiceStatus = (speaker, emotion) => {
      const emotionVoice = getCharacterEmotionVoice(speaker, emotion);

      if (!emotionVoice) {
          return "not_trained";
      }

      const apiStatus = String(emotionVoice.status || "")
          .trim()
          .toLowerCase();

      if (apiStatus === "censored") {
          return "censored";
      }

      if (
          apiStatus === "available" ||
          apiStatus === "trained" ||
          emotionVoice.voiceId ||
          emotionVoice.voice_id
      ) {
          return "available";
      }

      return "not_trained";
  };


  // const handleTrainVoice = (entry, emotion) => {
  //     // connect this to your training API / existing train function
  //     console.log("Train voice:", {
  //         speaker: entry.speaker,
  //         emotion,
  //     });
  // };
  // async function createListOfAudiosAndText() {
  //   try {
  //     const response = await axios.post(CREATE_LIST_AUDIOS_TEXTS, {
  //       projectId: projectFile.id,
  //       baseDirectory: projectFile.name,
  //     });

  //     toast.success(
  //       "The process of generating the list of drop downs has been activated"
  //     );
  //     console.log(await response.data.result);
  //     // resolve(response.data.result);
  //   } catch (error) {
  //     toast.error("An Error has occured while Translating");
  //   }
  // }

  // async function audioTraining() {
  //   if (!characters[0]?.voices?.length > 0) {
  //     try {
  //       const response = await axios.post(VOICE_TRAINING, {
  //         projectId: projectFile.id,
  //       });
  //       toast.success("The Movie voice id has been trained and added");
  //       // setcheckAudioTrainingStatus(true);
  //     } catch (error) {
  //       toast.error("An Error has occured while training the voices");
  //     }
  //   }
  // }

  // async function generateVocals() {
  //   for (const language of projectFile.finalLang) {
  //     try {
  //       const response = await axios.post(CREATE_ALL_VOCALS_AUTOMATICALLY, {
  //         projectId: projectFile.id,
  //         language: language,
  //         projectName: projectFile.name,
  //       });

  //       toast.success(
  //         "Translated vocals has been added for  all dialogues " +
  //           getLanguageName(language)
  //       );
  //     } catch (error) {
  //       toast.error("An Error has occured while Translating");
  //     }
  //   }
  // }

  const evaluateAllVoices = async () => {
    try {
      const response = await axios.post(EVALUATE_ALL_VOICES, {
        projectId: projectFile.id,
      });
      toast.success("The process of evaluating all voices has been activated");
      console.log(await response.data.result);
    }
    catch (error) {
      toast.error("An Error has occured while evaluating the voices");
    }
  };

  const finalSubmission = async () => {
    console.log(isConfirmationOpen)
    if (loading || isConfirmationOpen) return;

    setIsConfirmationOpen(true);
    setLoading(true);

    try {
      console.log("Starting validation for project:", projectFile.id);

      const validationResponse = await axios.post(VALIDATE_EMOTIONS, {
        projectId: projectFile.id,
      });
      setIsConfirmationOpen(true);
      console.log("Validation Response:", validationResponse.data);

      if (validationResponse.data.warnings && !warningShown) {
        const TOAST_ID = "voice-processing-confirmation";

        if (toast.isActive(TOAST_ID)) return;

        toast(
          <WarningToastWithOverlay
            message={validationResponse.data.warnings}
            toastId={TOAST_ID}
            onConfirm={async () => {
              await proceedWithProcessing();
              setWarningShown(true);
              setIsConfirmationOpen(false);
            }}
          />,
          {
            toastId: TOAST_ID,
            autoClose: false,
            closeOnClick: false,
            draggable: false,
            position: "top-center",
            onClose: () => setIsConfirmationOpen(false),
            style: {
              background: 'transparent',
              boxShadow: 'none',
              padding: 0,
              minHeight: 'unset',
              width: '400px'
            }
          }
        );
      } else {
        await proceedWithProcessing();
        setIsConfirmationOpen(false);
      }
    } catch (err) {
      console.error("Error during validation:", err);
      const errorMessage =
        err.response && err.response.status === 400
          ? err.response.data.details ||
          "Error validating voice data. Please check dialogue ratings."
          : err.message;
      toast.error(`Error in validation: ${errorMessage}`);
      setIsConfirmationOpen(false); // Reset confirmation state on error
    } finally {
      setLoading(false);
    }
  };


  const proceedWithProcessing = async () => {
    try {
      toast.info("Processing voice data...");

      setLoading(true); // Start loading

      // Call processing endpoint
      const processingResponse = await axios.post(
        AUTOMATIC_VOICE_PROCESSING,
        {
          projectId: projectFile.id,
        }
      );

      console.log("Processing Response:", processingResponse.data);

      // Show success toast
      toast.success("Voice processing completed successfully");
    } catch (err) {
      console.error("Error during processing:", err);

      if (err.response) {
        console.error("Error response:", {
          status: err.response.status,
          data: err.response.data,
          headers: err.response.headers,
        });
      } else if (err.request) {
        console.error("Error request:", err.request);
      } else {
        console.error("Error message:", err.message);
      }

      // Handle specific error case for 400 status or general error
      const errorMessage =
        err.response && err.response.status === 400
          ? err.response.data.details ||
          "Error processing voice data. Please check dialogue ratings."
          : err.message;

      toast.error(`Error in processing: ${errorMessage}`);
    } finally {
      setLoading(false); // End loading
    }
  };

  const applyTranscriberDialoguePage = useCallback((dialogues = []) => {
    const preparedDialogues = dialogues.map((dia, index) => ({
      ...dia,
      add: false,
      id: index,
      originalAudioRating: parseDropdownRatingValue(dia.originalAudioRating),
    }));

    const nextSubtitleMap = {};

    preparedDialogues.forEach((dia) => {
      nextSubtitleMap[dia.dbid] = dia.subtitleOnly || false;
    });

    setAudioData(preparedDialogues);
    setSubtitleOnlyMap(nextSubtitleMap);

    return preparedDialogues;
  }, []);

  const getDialoguesFromResponse = (responseData) => {
    return (
      responseData?.projectsArray ||
      responseData?.dialogues ||
      responseData?.results ||
      []
    );
  };

  const getDialogueCountFromResponse = (responseData, fallbackCount) => {
    return Number(
      responseData?.totalCount ??
        responseData?.count ??
        responseData?.numberOfDialogues ??
        fallbackCount ??
        0
    );
  };





  const loadFirstDialoguePage = useCallback(async () => {
    if (!projectFile?.id || !userInfo?.id) {
      return;
    }

    setLoader(true);

    try {
      const response = await axios.post(GET_SPEECH_FOR_PROJECT_BY_PAGE, {
        userId: userInfo.id,
        projectId: projectFile.id,
        action: "first",
        Current: null,
        pageName: "transcribe",
      });

      const dialogues = await response.data.projectsArray;

      console.log(
        "Dialogues from server:",
        dialogues.map((d) => ({
          id: d.dbid,
          subtitleOnly: d.subtitleOnly,
        }))
      );

      if (dialogues.length <= 0) {
        toast.error("The transcription service didn't finish yet");
      }

      applyTranscriberDialoguePage(dialogues);
      setPageNumber(1);
    } catch (err) {
      console.log(err);
    } finally {
      setLoader(false);
    }
  }, [
    applyTranscriberDialoguePage,
    projectFile?.id,
    userInfo?.id,
  ]);

  const loadSearchDialoguesPage = useCallback(
    async (filters, targetPageNumber = 1) => {
      if (!projectFile?.id || !userInfo?.id || !originalLanguageCode) {
        return;
      }

      setLoader(true);
      setPageButtonActivity(true);

      try {
        const response = await axios.post(SEARCH_SPEECH_FOR_PROJECT, {
          userId: userInfo.id,
          projectId: projectFile.id,

          // Transcriber only searches original text.
          languageCode: originalLanguageCode,
          originalLanguageCode,
          searchIn: originalLanguageCode,

          pageName: "transcribe",
          pageNumber: Number(targetPageNumber),
          itemsPerPage,

          searchText: filters.searchText?.trim() || "",
          speaker: filters.speaker || "",
          originalAudioEmotion: filters.originalAudioEmotion || "",

          // Intentionally unused on Transcriber.
          hasTranslatedAudio: "",
        });

        const dialogues = getDialoguesFromResponse(response.data);
        const totalCount = getDialogueCountFromResponse(
          response.data,
          dialogues.length
        );

        applyTranscriberDialoguePage(dialogues);
        setSearchResultCount(totalCount);
        setIsDialogueSearchActive(
          hasAnyDialogueSearchFilter({
            ...filters,
            hasTranslatedAudio: "",
          })
        );
        setPageNumber(Number(targetPageNumber));
        setPageInput(String(targetPageNumber));
      } catch (err) {
        console.error(err);
        toast.error("Error in searching dialogues");
      } finally {
        setLoader(false);
        setPageButtonActivity(false);
      }
    },
    [
      applyTranscriberDialoguePage,
      originalLanguageCode,
      projectFile?.id,
      userInfo?.id,
    ]
  );

  const handleDialogueSearch = async (filters) => {
    const normalizedFilters = {
      ...DEFAULT_DIALOGUE_SEARCH_FILTERS,
      ...filters,
      searchText: filters.searchText?.trim() || "",
      searchIn: originalLanguageCode || "all",
      hasTranslatedAudio: "",
    };

    setDialogueSearchFilters(normalizedFilters);

    if (!hasAnyDialogueSearchFilter(normalizedFilters)) {
      setIsDialogueSearchActive(false);
      setSearchResultCount(0);
      await loadFirstDialoguePage();
      return;
    }

    await loadSearchDialoguesPage(normalizedFilters, 1);
  };

  const handleClearDialogueSearch = async () => {
    setDialogueSearchFilters({
      ...DEFAULT_DIALOGUE_SEARCH_FILTERS,
      searchIn: originalLanguageCode || "all",
      hasTranslatedAudio: "",
    });

    setIsDialogueSearchActive(false);
    setSearchResultCount(0);

    await loadFirstDialoguePage();
  };





  // const nextPrevPageAPI = async (action) => {
  //   setPageButtonActivity(true);
  //   if (pageNumber === 1 && action === "previous") {
  //     return;
  //   }

  //   try {
  //     const response = await axios.post(GET_SPEECH_FOR_PROJECT_BY_PAGE, {
  //       userId: userInfo.id,
  //       projectId: projectFile.id,
  //       action: action,
  //       pageName: "transcribe",
  //     });

  //     if (response.data) {
  //       const sortedArray = await response.data.projectsArray;

  //       // Debug log
  //       console.log("Page navigation dialogues:", sortedArray.map(d => ({
  //         id: d.dbid,
  //         subtitleOnly: d.subtitleOnly
  //       })));

  //       sortedArray.forEach((dia, index) => {
  //         dia.add = false;
  //         dia.id = index;
  //         dia.originalAudioRating = parseDropdownRatingValue(
  //           dia.originalAudioRating
  //         );
  //         // Keep subtitleOnly exactly as received from server
  //       });

  //       // Update subtitle map directly from server values
  //       const newSubtitleMap = {};
  //       sortedArray.forEach(dia => {
  //         newSubtitleMap[dia.dbid] = dia.subtitleOnly;
  //       });

  //       setAudioData(sortedArray);
  //       setSubtitleOnlyMap(newSubtitleMap);

  //       if (action === "next") {
  //         setPageNumber((prev) => Number(prev) + 1);
  //       } else if (action === "previous") {
  //         setPageNumber((prev) => Number(prev) - 1);
  //       }
  //       setPageButtonActivity(false);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //     toast.error("Error in getting the next page");
  //     setPageButtonActivity(false);
  //   }
  // };


  const nextPrevPageAPI = async (action) => {
    setPageButtonActivity(true);

    const targetPageNumber =
      action === "next" ? Number(pageNumber) + 1 : Number(pageNumber) - 1;

    if (targetPageNumber < 1 || targetPageNumber > totalPages) {
      setPageButtonActivity(false);
      return;
    }

    if (isDialogueSearchActive) {
      await loadSearchDialoguesPage(dialogueSearchFilters, targetPageNumber);
      return;
    }

    try {
      const response = await axios.post(GET_SPEECH_FOR_PROJECT_BY_PAGE, {
        userId: userInfo.id,
        projectId: projectFile.id,
        action: action,
        pageName: "transcribe",
      });

      if (response.data) {
        const sortedArray = await response.data.projectsArray;

        console.log(
          "Page navigation dialogues:",
          sortedArray.map((d) => ({
            id: d.dbid,
            subtitleOnly: d.subtitleOnly,
          }))
        );

        applyTranscriberDialoguePage(sortedArray);
        setPageNumber(targetPageNumber);
      }
    } catch (err) {
      console.log(err);
      toast.error("Error in getting the next page");
    } finally {
      setPageButtonActivity(false);
    }
  };





  const goToPageAPI = async (number) => {
    setLoader(true);

    try {
      let pageToLoad = Number(number);

      if (!pageToLoad || Number.isNaN(pageToLoad)) {
        setLoader(false);
        setPageInput(String(pageNumber));
        return;
      }

      if (!totalPages) {
        setLoader(false);
        setPageInput(String(pageNumber));
        return;
      }

      if (pageToLoad < 1) {
        pageToLoad = 1;
      }

      if (pageToLoad > totalPages) {
        pageToLoad = totalPages;
      }

      if (pageToLoad === Number(pageNumber)) {
        setLoader(false);
        setPageInput(String(pageNumber));
        return;
      }


      if (isDialogueSearchActive) {
        await loadSearchDialoguesPage(dialogueSearchFilters, pageToLoad);
        setLoader(false);
        return;
      }


      const response = await axios.post(GET_SPEECH_FOR_PROJECT_BY_PAGE, {
        userId: userInfo.id,
        projectId: projectFile.id,
        action: "goto",
        pageNumber: pageToLoad,
        pageName: "transcribe",
      });

      if (response.data) {
        const sortedArray = await response.data.projectsArray;
        // sortedArray.forEach((dia, index) => {
        //   dia.add = false;
        //   dia.id = index;
        //   dia.originalAudioRating = parseDropdownRatingValue(
        //     dia.originalAudioRating
        //   );
        // });

        // setAudioData(sortedArray);
        // setPageNumber(pageToLoad);
        // setLoader(false);

        applyTranscriberDialoguePage(sortedArray);
        setPageNumber(pageToLoad);
        setLoader(false);
      }
    } catch (err) {
      setLoader(false);
      console.log(err);
      toast.error("Error in getting the next page");
    }
  };

  // //apis - get dialogues
  // useEffect(() => {
  //   const fetchData = async () => {
  //     setLoader(true);
  //     try {
  //       const response = await axios.post(GET_SPEECH_FOR_PROJECT_BY_PAGE, {
  //         userId: userInfo.id,
  //         projectId: projectFile.id,
  //         action: "first",
  //         Current: null,
  //         pageName: "transcribe",
  //       });

  //       const dialogues = await response.data.projectsArray;

  //       // Debug log to check what's coming from the server
  //       console.log("Dialogues from server:", dialogues.map(d => ({
  //         id: d.dbid,
  //         subtitleOnly: d.subtitleOnly
  //       })));

  //       dialogues.forEach((dia, index) => {
  //         dia.add = false;
  //         dia.id = index;
  //         dia.originalAudioRating = parseDropdownRatingValue(
  //           dia.originalAudioRating
  //         );
  //         // We keep the subtitleOnly value exactly as it comes from the server
  //         // No need to modify it, as we want to preserve the server's state
  //       });

  //       if (dialogues.length <= 0) {
  //         toast.error("The transcription service didn't finish yet");
  //       }

  //       // Initialize the subtitle map directly from server values
  //       const initialSubtitleMap = {};
  //       dialogues.forEach(dia => {
  //         initialSubtitleMap[dia.dbid] = dia.subtitleOnly;
  //       });

  //       console.log("Initial subtitle map:", initialSubtitleMap);

  //       setAudioData(dialogues);
  //       setSubtitleOnlyMap(initialSubtitleMap);
  //       setLoader(false);
  //     } catch (err) {
  //       console.log(err);
  //       setLoader(false);
  //     }
  //   };
  //   fetchData();
  // }, [projectFile.id, userInfo.id]);


  useEffect(() => {
    loadFirstDialoguePage();
  }, [loadFirstDialoguePage]);


  //apis - get characters
  const fetchCharacters = useCallback(async () => {
    try {
      const response = await axios.post(GET_CHARACTERS_FOR_PROJECT, {
        projectId: projectFile.id,
      });

      // Filter out characters marked as unused (isUsed === false)
      const activeCharacters = response.data.characters.filter(
        (char) => char.isUsed !== false // Show characters where isUsed is undefined, null, or true
      );

      setCharacters(activeCharacters);
    } catch (err) {
      console.log(err);
    }
  }, [projectFile.id]);

  useEffect(() => {
    fetchCharacters();
  }, [fetchCharacters]);

  const statusColorMap = {
    red: "#d32f2f",
    yellow: "#f9a825",
    green: "#2e7d32",
  };

  const getReadinessStatus = useCallback((count) => {
    if (count >= CHARACTER_GOOD_READY_DIALOGUES) {
      return { level: "green", label: "Ready" };
    }

    if (count >= CHARACTER_MINIMUM_READY_DIALOGUES) {
      return { level: "yellow", label: "Minimum" };
    }

    return { level: "red", label: "Not Ready" };
  }, []);

  const characterProgressEntries = useMemo(() => {
    if (!transcriptionStats?.charactersStats) {
      return [];
    }

    const characterStates = transcriptionStats.characterStates ?? {};

    return Object.entries(transcriptionStats.charactersStats)
      .map(([speaker, stats]) => {
        // Gather every dialogue instance for the current speaker
        const dialogues = Object.values(stats.dialogues || {});
        const ratingCounts = {};
        const emotionCounts = {};
        let unratedCount = 0;

        // Seed counters with the standard rating and emotion options
        AVAILABLE_RATINGS.forEach((rating) => {
          ratingCounts[rating] = 0;
        });

        DEFAULT_EMOTIONS.forEach((emotion) => {
          emotionCounts[emotion] = { total: 0, highRated: 0 };
        });

        // Accumulate rating and emotion tallies from each dialogue
        dialogues.forEach((dialogue) => {
          const ratingValueRaw = dialogue.originalAudioRating;
          const ratingValue = Number(ratingValueRaw);
          const ratingIsProvided =
            ratingValueRaw !== null && ratingValueRaw !== undefined && ratingValueRaw !== "";
          // A rating of 0 (or other non-positive numbers) indicates "not yet rated"
          // in the source data, so treat those cases as missing before tallying.
          const ratingIsPositiveNumber =
            ratingIsProvided && !Number.isNaN(ratingValue) && ratingValue > 0;

          if (ratingIsPositiveNumber) {
            if (ratingCounts[ratingValue] === undefined) {
              ratingCounts[ratingValue] = 0;
            }
            ratingCounts[ratingValue] += 1;
          }

          const emotionValue = dialogue.originalAudioEmotion;
          if (emotionValue) {
            if (emotionCounts[emotionValue] === undefined) {
              emotionCounts[emotionValue] = { total: 0, highRated: 0 };
            }

            emotionCounts[emotionValue].total += 1;

            if (ratingIsPositiveNumber && ratingValue >= 4) {
              emotionCounts[emotionValue].highRated += 1;
            }
          }
        });

        const characterState = characterStates[speaker];
        if (
          characterState &&
          Object.prototype.hasOwnProperty.call(characterState, "unratedDialogueCount")
        ) {
          const unratedValue = Number(characterState.unratedDialogueCount);
          if (Number.isFinite(unratedValue)) {
            unratedCount = unratedValue;
          }
        } else {
          console.log(
            `[TranscriberScreen] unratedDialogueCount field was not found in the datamodel for speaker ${speaker}; defaulting to 0.`
          );
        }

        // Prefer the friendly display name but fall back to the speaker id
        const matchingCharacter = characters.find(
          (char) => char.speaker === speaker
        );

        const displayName = matchingCharacter
          ? matchingCharacter.displayName || matchingCharacter.speaker
          : speaker;

        const highRatingCount =
          (ratingCounts[4] ?? 0) + (ratingCounts[5] ?? 0);

        // Determine readiness status from the tally of high-rated dialogues.
        let statusLevel = "red";
        let statusLabel = "Not Ready";

        if (highRatingCount >= CHARACTER_GOOD_READY_DIALOGUES) {
          statusLevel = "green";
          statusLabel = "Ready";
        } else if (highRatingCount >= CHARACTER_MINIMUM_READY_DIALOGUES) {
          statusLevel = "yellow";
          statusLabel = "Minimum";
        }

        return {
            speaker,
            displayName,
            ratingCounts,
            emotionCounts,
            statusLevel,
            statusLabel,
            dialogueCount: dialogues.length,
            isImportedVoice: Boolean(matchingCharacter?.projectId),
            unratedCount,
        };
      })
      .filter((entry) => {
        const normalizedName = `${entry.displayName || entry.speaker}`.trim();
        return normalizedName !== "" || entry.dialogueCount > 0;
      });
  }, [transcriptionStats, characters]);

  const tableStatusLevel = useMemo(() => {
    if (characterProgressEntries.length === 0) {
      return null;
    }

    if (characterProgressEntries.some((entry) => entry.statusLevel === "red")) {
      return "red";
    }

    if (
      characterProgressEntries.some((entry) => entry.statusLevel === "yellow")
    ) {
      return "yellow";
    }

    return "green";
  }, [characterProgressEntries]);

  const ratingSummaryRows = useMemo(() => {
    const baseRows = [
      {
        key: "five-stars",
        label: "5 Stars",
        ratingValues: [5],
      },
      {
        key: "four-stars",
        label: "4 Stars",
        ratingValues: [4],
      },
      {
        key: "three-or-less",
        label: "3 Stars or Less",
        ratingValues: [3, 2, 1],
      },
    ];

    const additionalRatings = new Set();

    characterProgressEntries.forEach((entry) => {
      Object.keys(entry.ratingCounts).forEach((rating) => {
        const ratingValue = Number(rating);
        const isStandardRating = [1, 2, 3, 4, 5].includes(ratingValue);
        if (
          Number.isFinite(ratingValue) &&
          ratingValue > 0 &&
          !isStandardRating
        ) {
          additionalRatings.add(ratingValue);
        }
      });
    });

    const extraRows = Array.from(additionalRatings)
      .sort((a, b) => b - a)
      .map((ratingValue) => ({
        key: `rating-${ratingValue}`,
        label: `${ratingValue} Star${ratingValue === 1 ? "" : "s"}`,
        ratingValues: [ratingValue],
      }));

    const unratedRow = {
      key: "unrated",
      label: "Unrated",
      ratingValues: [],
      isUnrated: true,
    };

    return [...baseRows, ...extraRows, unratedRow];
  }, [characterProgressEntries]);

  const emotionKeys = useMemo(() => {
    const extraEmotions = new Set();

    characterProgressEntries.forEach((entry) => {
      Object.keys(entry.emotionCounts).forEach((emotion) => {
        if (!DEFAULT_EMOTIONS.includes(emotion)) {
          extraEmotions.add(emotion);
        }
      });
    });

    return [...DEFAULT_EMOTIONS, ...Array.from(extraEmotions)];
  }, [characterProgressEntries]);

  //apis - check final submission status
  useEffect(() => {
    const checkChoppingStatus = async () => {
      try {
        const response = await axios.post(AUDIO_CHOPPING_STATUS_CHECK, {
          projectId: projectFile.id,
        });

        setCheckChoppingStatus(response.data.status);
      } catch (err) {
        console.log(err);
      }
    };
    const checkAudioTrainingStatus = async () => {
      try {
        const response = await axios.post(VOICE_TRAINING_STATUS_CHECK, {
          projectId: projectFile.id,
        });

        setCheckChoppingStatus(response.data.status);
      } catch (err) {
        console.log(err);
      }
    };

    checkChoppingStatus();
    checkAudioTrainingStatus();
  }, [projectFile.id]);

  const handleTimeSync = async (time) => {
    try {
      setLoader(true);
      const positionResponse = await axios.post(GET_SPEECH_POSITION_AROUND_TIME, {
        projectId: projectFile.id,
        time: time
      });

      const number = Math.ceil(positionResponse.data.firstPosition / 10);

      const response = await axios.post(GET_SPEECH_FOR_PROJECT_BY_PAGE, {
        userId: userInfo.id,
        projectId: projectFile.id,
        action: "goto",
        pageNumber: number,
        pageName: "transcribe",
      });

      if (response.data) {
        const sortedArray = await response.data.projectsArray;
        sortedArray.forEach((dia, index) => {
          dia.add = false;
          dia.id = index;
          dia.originalAudioRating = parseDropdownRatingValue(
            dia.originalAudioRating
          );
        });

        setAudioData(sortedArray);
        setPageNumber(number);
        setLoader(false);
      }
    } catch (err) {
      setLoader(false);
      console.log(err);
      toast.error("Error syncing to current time position");
    }
  };

  const handlePageInputSubmit = () => {
    if (!totalPages) {
      setPageInput(String(pageNumber));
      return;
    }

    if (!pageInput) {
      setPageInput(String(pageNumber));
      return;
    }

    const parsedValue = Number(pageInput);

    if (Number.isNaN(parsedValue)) {
      setPageInput(String(pageNumber));
      return;
    }

    const clampedValue = Math.min(Math.max(parsedValue, 1), totalPages);

    if (clampedValue === Number(pageNumber)) {
      setPageInput(String(clampedValue));
      return;
    }

    goToPageAPI(clampedValue);
  };

  const handlePageInputChange = (event) => {
    const { value } = event.target;

    if (value === "") {
      setPageInput("");
      return;
    }

    if (/^\d+$/.test(value)) {
      setPageInput(value);
    }
  };

  const handlePageInputKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handlePageInputSubmit();
    }
  };

  const handleSubtitleOnlyChange = async (dialogueId, isSubtitleOnly) => {
    try {
      console.log(`Changing subtitle status for ${dialogueId} to:`, isSubtitleOnly);

      const updatedData = [...audioData];
      const dialogueIndex = updatedData.findIndex(item => item.dbid === dialogueId);

      if (dialogueIndex === -1) {
        toast.error("Dialogue not found");
        return;
      }

      // Update the local state first
      updatedData[dialogueIndex] = {
        ...updatedData[dialogueIndex],
        subtitleOnly: isSubtitleOnly
      };

      setAudioData(updatedData);

      // Update the subtitle map
      setSubtitleOnlyMap({
        ...subtitleOnlyMap,
        [dialogueId]: isSubtitleOnly
      });

      // Send update to backend
      const response = await axios.post(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: updatedData[dialogueIndex]
      });

      if (response.data) {
        console.log(`Subtitle status updated successfully for ${dialogueId}:`, isSubtitleOnly);
      }
    } catch (err) {
      console.error("Error updating subtitle status:", err);
      toast.error("Error updating subtitle status");

      // Revert the local state change if the API call fails
      const originalData = [...audioData];
      const originalIndex = originalData.findIndex(item => item.dbid === dialogueId);

      if (originalIndex !== -1) {
        const originalSubtitleValue = !isSubtitleOnly; // The original value would be the opposite

        setSubtitleOnlyMap({
          ...subtitleOnlyMap,
          [dialogueId]: originalSubtitleValue
        });
      }
    }
  };

  // Initialize subtitle map when dialogues are loaded
  useEffect(() => {
    if (audioData && audioData.length > 0) {
      const newSubtitleMap = {};
      audioData.forEach(dialogue => {
        newSubtitleMap[dialogue.dbid] = dialogue.subtitleOnly || false;
      });
      setSubtitleOnlyMap(newSubtitleMap);
    }
  }, [audioData]);


  const showAssignCharacterConfirmation = (character) => {
    const TOAST_ID = `assign-character-${character.speaker}`;

    if (toast.isActive(TOAST_ID)) return;

    const characterName = character.displayName || character.speaker;

    toast(
      <div>
        <p>Assigning '{characterName}' to all dialogues. Are you sure?</p>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px', gap: '8px' }}>
          <Button
            size="small"
            onClick={() => {
              toast.dismiss(TOAST_ID);
              console.log('Cancelled assigning character to all dialogues');
            }}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={() => {
              toast.dismiss(TOAST_ID);
              handleAssignCharacterToAll(character);
            }}
          >
            Yes
          </Button>
        </div>
      </div>,
      {
        toastId: TOAST_ID,
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        closeButton: false,
        position: "top-center",
        style: {
          minWidth: '300px',
          maxWidth: '400px'
        }
      }
    );
  };

  const handleAssignCharacterToAll = async (character) => {
    const characterName = character.displayName || character.speaker;
    console.log(`Assigning ${characterName} to all dialogues`);

    try {
      setLoader(true); // Show loading indicator

      const response = await axios.post(Assign_Character_To_All_Dialogues, {
        projectId: projectFile.id,
        speaker: character.speaker
      });

      if (response.data.success) {
        // Refresh the current page of dialogues to show updated speakers
        const refreshResponse = await axios.post(GET_SPEECH_FOR_PROJECT_BY_PAGE, {
          userId: userInfo.id,
          projectId: projectFile.id,
          action: "goto",
          pageNumber: pageNumber,
          pageName: "transcribe",
        });

        if (refreshResponse.data) {
          const updatedDialogues = refreshResponse.data.projectsArray;
          updatedDialogues.forEach((dia, index) => {
            dia.add = false;
            dia.id = index;
            dia.originalAudioRating = parseDropdownRatingValue(
              dia.originalAudioRating
            );
          });

          setAudioData(updatedDialogues);
          toast.success(`Successfully assigned ${characterName} to ${response.data.count} dialogues`);
        }
      } else {
        toast.error("Failed to assign character to all dialogues");
      }
    } catch (error) {
      console.error("Error assigning character to all dialogues:", error);
      toast.error("An error occurred while assigning character to all dialogues");
    } finally {
      setLoader(false); // Hide loading indicator
    }
  };

  return (
    <Grid
      item
      container
      // justifyContent={{ xl: "center", lg: "center", md: "center" }}
      justifyContent="center"
      marginTop={2}
    >
      <Loader Load={audioLoader} />
      <Loader Load={loader} />
      <ToastContainer position="top-center" />
      <Grid item container xs={11.5} direction="column">
        <Grid item container direction="row">
          <Box
            sx={{
              width: {
                xs: "100%",
                sm: "100%",
                md: "100%",
                lg: "41.6667%",
                xl: "48.75%",
              },
              marginRight: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "stretch",
              flexShrink: 0,
              minWidth: 0,
            }}
          >
            <Grid
              item
              container
              className={
                openCharactersFolder
                  ? classes["OnAudioFiles"]
                  : classes["OffAudioFiles"]
              }
              direction="column"
            >
              <Grid
                item
                container
                direction="row"
                alignItems="center"
                className={classes["AudioTitles"]}
                justifyContent="space-between"
              >
                <Grid item container marginLeft={1.5} xs={3} direction="row">
                  <Grid
                    item
                    marginRight={1}
                    className={classes["AudioTitleFont"]}
                  >
                    <GroupsIcon fontSize="medium" />
                  </Grid>
                  <Grid item className={classes["AudioTitleFont"]}>
                    Characters
                  </Grid>
                </Grid>

                {/* <Grid item container marginLeft={1.5} xs={4} direction="row" style={{ display: 'flex', flexWrap: 'nowrap' }}>
                  <Grid item xs={1} marginRight={23}>
                    <textarea
                      className={classes["AudioWorkSpeakerEditInput"]}
                      value={charName.displayName}
                      type="text"
                      onChange={(e) =>
                        setCharName({
                          ...charName,
                          displayName: formatInputs(e.target.value),
                        })
                      }
                      placeholder="Enter Character Name"
                    ></textarea>
                  </Grid>
                  <Grid xs={1} item>
                    <TaskButton
                      onClick={AddNewCharacter}
                      height="24px"
                      style={{ padding: 3 }}
                    >
                      Add
                    </TaskButton>
                  </Grid>
                </Grid> */}

                <Grid item container marginLeft={1.5} xs={4} direction="row" style={{ display: 'flex', flexWrap: 'nowrap' }}>
                  <Grid item xs={1} marginRight={3}>
                    <CharacterInput
                      projectId={projectFile.id}
                      existingCharacters={characters}
                      onAddNewCharacter={(displayName) => {
                        if (!displayName.trim()) {
                          toast.error("Enter a name");
                          return;
                        }
                        const speakerId = `SPEAKER_${Math.floor(Math.random() * 999)}${Math.floor(Math.random() * 999)}`;
                        const newChar = {
                          speaker: speakerId,
                          voices: [],
                          displayName
                        };

                        // Append only the new character
                        axios.post(APPEND_CHARACTER, {
                          projectId: projectFile.id,
                          character: {
                            ...newChar,
                            isUsed: true
                          }
                        })
                          .then(() => {
                            setCharacters(prev => [...prev, { ...newChar, isUsed: true }]);
                            toast.success("A new character has been added");
                          })
                          .catch(err => {
                            console.error("Error adding new character:", err);
                            toast.error("Error in adding the new character");
                          });
                      }}
                      onSelectImportedCharacter={(character) => {
                        const restored = {
                          ...character,
                          isUsed: true,
                          isImported: true,
                          isRestored: true
                        };

                        // Append only the restored character
                        axios.post(APPEND_CHARACTER, {
                          projectId: projectFile.id,
                          character: restored
                        })
                          .then(() => {
                            setCharacters(prev => [...prev, restored]);
                            toast.success("Character restored successfully");
                          })
                          .catch(err => {
                            console.error("Error restoring character:", err);
                            toast.error("Failed to restore character");
                          });
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid
                  item
                  fontSize="var(--font-size-header)"
                  onClick={() => {
                    setOpenCharactersFolder(!openCharactersFolder);
                  }}
                  sx={{ cursor: "pointer" }}
                  className={classes["AudioTitleFont"]}
                  marginRight={2}
                >
                  {openCharactersFolder ? (
                    <KeyboardArrowUpIcon fontSize="large" />
                  ) : (
                    <KeyboardArrowDownIcon fontSize="large" />
                  )}
                </Grid>
              </Grid>
              <Grid
                container
                item
                className={classes["AudioFilesBoxScroller"]}
                xs={8}
                ref={characterListContainerRef}
              >
                {openCharactersFolder ? (
                  <Grid
                    item
                    container
                    direction="row"
                    gap={1}
                    marginTop={0.5}
                    marginLeft={0.5}
                  >
                    {sortedCharacters.map((char, index) => (
                      <Grid
                        key={char.speaker || index}
                        container
                        item
                        xs={5}
                        sm={5.5}
                        md={2.5}
                        lg={5.5}
                        xl={2.6}
                        alignItems="center"
                        height="40px"
                        sx={{
                            fontSize: "var(--font-size-normal)",
                            borderRadius: "var(--radius-md)",
                            overflow: "hidden", // Prevent content from overflowing
                            minWidth: "240px", // Ensure minimum width to prevent squishing
                            maxWidth: "240px"
                        }}
                        bgcolor="var(--color-dropdown-bg)"
                      >
                        <Grid
                          item
                          xs={2}
                          color={primaryColor}
                          sx={{
                            paddingLeft: 0.4,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          <ContactsIcon />
                        </Grid>
                        <Grid
                          item
                          xs={6}
                          color="var(--color-body-text)"
                          sx={{
                              display: "flex",
                              alignItems: "center"
                          }}
                        >
                          <textarea
                            ref={(element) => {
                                if (element) {
                                    characterNameInputRefs.current[char.speaker] = element;
                                } else {
                                    delete characterNameInputRefs.current[char.speaker];
                                }
                            }}
                            className={classes["CharacterWorkSpeakerEditInput"]}
                            value={
                                char.displayName?.length >= 0
                                    ? char.displayName
                                    : char.speaker
                            }
                            type="text"
                            onFocus={() => handleCharacterNameFocus(char.speaker)}
                            onBlur={() => handleCharacterNameBlur(char.speaker)}
                            onKeyDown={(event) =>
                                handleCharacterNameKeyDown(event, char.speaker)
                            }
                            onChange={(event) =>
                                handleCharacterNameChange(
                                    char.speaker,
                                    event.target.value
                                )
                            }
                            style={{ width: "85%" }}
                          ></textarea>
                        </Grid>

                        {/* Updated character action icons grid - conditional spacing based on imported status */}
                        <Grid
                          item
                          xs={4}
                          sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: !!char.projectId ? "space-between" : "flex-end", // Different justification based on import status
                              padding: "0 4px"
                          }}
                        >
                          {!!char.projectId ? (
                            // If it's an imported character, show the import indicator with space between
                            <>
                              {!!char.projectId && (
                                <div title="Imported Character" style={{
                                  color: "#FFD700",
                                  fontSize: "var(--font-size-normal)",
                                  flexShrink: 0 // Prevent shrinking
                                }}>
                                  ↙️
                                </div>
                              )}

                              {/* New icon button */}
                              <div
                                title="Download/Export"
                                style={{
                                  cursor: "pointer",
                                  color: "#1da1f2", // Twitter blue color to match icon
                                  // padding: '2px',
                                  display: 'flex',
                                  alignItems: 'center'
                                }}
                              >
                                <div title="Imported Character"
                                  onClick={() => showAssignCharacterConfirmation(char)}
                                  style={{
                                    color: "#FFD700",
                                    fontSize: "var(--font-size-normal)",
                                    flexShrink: 0
                                  }}>
                                  ↕️
                                </div>
                              </div>

                              <Grid
                                item
                                onClick={() => removeCharacter(char.speaker, !!char.projectId)}
                                sx={{
                                  cursor: "pointer",
                                  color: "red",
                                  flexShrink: 0, // Prevent shrinking
                                  // padding: '2px'
                                }}
                              >
                                <DeleteIcon style={{ fontSize: 'var(--font-size-header)', marginTop: '4px' }} />
                              </Grid>
                            </>
                          ) : (
                            // If it's not an imported character, group icons more closely
                            <>
                              <div
                                title="Assign Character to All"
                                onClick={() => showAssignCharacterConfirmation(char)}
                                style={{
                                  color: "#FFD700",
                                  fontSize: "var(--font-size-normal)",
                                  flexShrink: 0,
                                  cursor: "pointer",
                                  marginRight: '8px' // Reduced space between icons
                                }}
                              >
                                ↕️
                              </div>

                              <Grid
                                item
                                onClick={() => removeCharacter(char.speaker, false)}
                                sx={{
                                  cursor: "pointer",
                                  color: "red",
                                  flexShrink: 0
                                }}
                              >
                                <DeleteIcon style={{
                                  fontSize: 'var(--font-size-header)',
                                  marginTop: '4px',
                                  marginRight: '6px'
                                }} />
                              </Grid>
                            </>
                          )}
                        </Grid>
                      </Grid>
                    ))}
                  </Grid>
                ) : (
                  <></>
                )}
              </Grid>
            </Grid>

            {workPlaceType ? (
            <Box
              sx={{
                width: "100%",
                maxWidth: "100%",
                mt: 1,
                mb: 1,
                flex: "0 0 auto",
                minHeight: "unset",
                minWidth: 0,
              }}
            >
              <DialogueSearchFilter
                value={dialogueSearchFilters}
                onChange={setDialogueSearchFilters}
                onSearch={handleDialogueSearch}
                onClear={handleClearDialogueSearch}
                characters={sortedCharacters}
                emotionOptions={originalAudioEmotionOptions}
                loading={loader || pageButtonActivity}
                getSpeakerDisplayName={findDisplayName}
                originalLanguageCode={originalLanguageCode}
                translationLanguageCode=""
                showSearchScope={false}
                showGeneratedAudioFilter={false}
                searchPlaceholder="Search original dialogue text..."
              />
            </Box>
          ) : null}



            <Grid
              item
              container
              className={classes["AudioWorkPlace"]}
              marginTop={0}
              direction="column"
              gap={3}
            >
              <Grid
                item
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                wrap="nowrap"
                className={classes["AudioTitles"]}
              >
                <Grid
                  item
                  container
                  marginLeft={1.5}
                  className={classes["AudioTitleFont"]}
                  alignItems="center"
                  columnGap={1}
                  wrap="nowrap"
                >
                  <Grid item>
                    <AutoStoriesIcon fontSize="medium" />
                  </Grid>
                  <Grid item>Dialogue</Grid>
                </Grid>
                <Grid
                  item
                  marginRight={1.5}
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                >
                  <TaskButton
                    className={classes["AudioWorkPlaceButton"]}
                    onClick={() => setWorkPlaceType(!workPlaceType)}
                  >
                    SFX / DX
                  </TaskButton>
                </Grid>
                {/* <Grid item marginRight={4.5}>
                  <button
                    className={classes["AudioWorkPlaceButton"]}
                    onClick={() =>
                      videoSource === projectFile.videoUrl
                        ? setVidoSource(projectFile.dialogueAudioUrl)
                        : setVidoSource(projectFile.videoUrl)
                    }
                  >
                    Sound Effects on/off
                  </button>
                </Grid> */}
              </Grid>
              <Grid item container>
                <Grid
                  item
                  container
                  direction="row"
                  marginBottom={1.5}
                  gap={2}
                  className={classes["AudioWorkPlaceChatBoxScroller"]}
                  maxHeight={{
                    xl: "800px",
                    lg: "800px",
                    md: "800px",
                    xs: "360px",
                  }}
                  ref={containerRef}
                >
                  {audioData && workPlaceType ? (
                    <>
                      {audioData.map((data, index) => {
                        const character = characters.find((c) => c.speaker === data.speaker);
                        const originalLanguageCode =
                          projectFile.originalLanguage || projectFile.orginalLang;
                        const confidenceEntry = data.translations?.find(
                          (translation) =>
                            translation.languageCode === originalLanguageCode
                        );
                        const transcriptionConfidence =
                          confidenceEntry?.transcriptionConfidence ??
                          data.translations?.[0]?.transcriptionConfidence;
                        const normalizedConfidence = (transcriptionConfidence || "")
                          .toString()
                          .trim()
                          .toLowerCase();
                        const showConfidenceWarning =
                          normalizedConfidence !== "" && normalizedConfidence !== "high";
                        return (
                          <React.Fragment key={index}>
                            <Grid item container direction="row">
                              <Grid
                                item
                                container
                                xs={1.8}
                                marginLeft={0.5}
                                direction="row"
                                alignItems="flex-start"
                                wrap="nowrap"
                                className={classes["AudioWorkPlaceTimeline"]}
                              >
                                {showConfidenceWarning && (
                                  <Grid item className={classes["AudioWorkPlaceTimelineWarning"]}>
                                    <Tooltip title="Transcription confidence is not high.">
                                      <WarningAmberIcon fontSize="small" />
                                    </Tooltip>
                                  </Grid>
                                )}
                                <Grid
                                  item
                                  container
                                  direction="column"
                                  justifyContent="center"
                                  alignContent="center"
                                >
                                  <Grid item marginBottom={1}>
                                    <textarea
                                      className={
                                        classes["AudioWorkPlaceTimelineEdit"]
                                      }
                                      value={formatTime(data.start)}
                                      type="text"
                                      onChange={(e) =>
                                        handleStartTimeChange(e, data.id)
                                      }
                                    ></textarea>
                                  </Grid>
                                  <Grid item>
                                    <textarea
                                      className={
                                        classes["AudioWorkPlaceTimelineEdit"]
                                      }
                                      value={formatTime(data.end)}
                                      type="text"
                                      onChange={(e) =>
                                        handleEndTimeChange(e, data.id)
                                      }
                                    ></textarea>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid
                                item
                                container
                                direction="row"
                                alignContent="center"
                                alignItems="center"
                                // bgcolor="red"
                                // gap={1}
                                // paddingLeft={1.5}
                                justifyContent="space-between"
                                paddingTop={0}
                                xs={9.4}
                                sx={{ cursor: "pointer" }}
                              >
                                <Grid
                                  item
                                  paddingLeft={1}
                                  xs={6.3}
                                  container
                                  className={classes["AudioWorkPlaceBoxes"]}
                                  alignContent="center"
                                  direction="row"
                                  onClick={() => {
                                    setSeekTime(data.start);
                                    setSeekTimeIndex(seekTimeIndex === 1 ? 2 : 1);
                                  }}
                                // bgcolor="red"
                                // width="px"
                                >
                                  <Grid item xs={12}>
                                    {data.speaker ? (
                                      <Grid display={"flex"} justifyContent={"space-between"}>
                                        <Grid
                                          width="200px"
                                          height="22px"
                                          marginBottom={0.5}
                                        >
                                          <Select
                                            value={data.speaker}
                                            onChange={(e) => handleSpeakerChange(e, data.id)}
                                            input={<BootstrapInputForAvalialbe />}
                                            onClick={handleCharacterSelectClick} // Prevents event bubbling
                                            onMouseDown={(e) => handleCharacterSelectMouseDown(e, data.speaker)} // Ensures menu interactions don't bubble
                                          >
                                            {sortedCharacters.map((char) => (
                                                <MenuItem
                                                  key={char.speaker}
                                                  value={char.speaker}
                                                  sx={{
                                                  display: "flex",
                                                  justifyContent: "space-between",
                                                  alignItems: "center"
                                                  }}
                                                >
                                                <span>{findDisplayName(char.speaker)}</span>
                                                {!!char.projectId && (
                                                  <span
                                                    title="Imported Character"
                                                    style={{
                                                      color: "#FFD700",
                                                      fontSize: "var(--font-size-normal)",
                                                      marginLeft: "4px"
                                                    }}
                                                  >
                                                    ↙️
                                                  </span>
                                                )}
                                              </MenuItem>
                                            ))}
                                          </Select>
                                        </Grid>

                                        <Grid item>
                                          <FormControlLabel
                                            control={
                                              <Checkbox
                                              checked={subtitleOnlyMap[data.dbid] || false}
                                              onChange={(e) =>
                                                handleSubtitleOnlyChange(data.dbid, e.target.checked)
                                              }
                                              size="small"
                                              onClick={(e) => e.stopPropagation()}
                                            />
                                            }
                                            label="Subtitle Only"
                                            sx={{
                                              marginLeft: "8px",
                                              "& .MuiFormControlLabel-label": {
                                                fontSize: "var(--font-size-normal)",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis"
                                              }
                                            }}
                                          />
                                        </Grid>
                                      </Grid>
                                    ) : (
                                      <Grid
                                        width="100px"
                                        height="22px"
                                        marginBottom={1}
                                      >
                                        <Select
                                          value={data.speaker}
                                          onChange={(e) =>
                                            handleSpeakerChange(e, data.id)
                                          }
                                          input={<BootstrapInput />}
                                          onClick={handleCharacterSelectClick}
                                          onMouseDown={(e) => handleCharacterSelectMouseDown(e, data.speaker)}
                                        >
                                          {sortedCharacters.map((char) => (
                                            <MenuItem
                                              key={char.speaker}
                                              value={char.speaker}
                                            >
                                              {findDisplayName(char.speaker)}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </Grid>
                                    )}
                                  </Grid>
                                  <Grid item xs={12}>
                                    <textarea
                                      className={
                                        classes["AudioWorkTextEditInput"]
                                      }
                                      style={{
                                        color:
                                          currentTime >= data.start &&
                                            currentTime < data.end
                                            ? "red"
                                            : "",
                                      }}
                                      value={data.text}
                                      type="text"
                                      onChange={(e) =>
                                        handleTextChange(e, data.id)
                                      }
                                    ></textarea>
                                  </Grid>
                                </Grid>

                                <Grid item xs={1}>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={data.faceCheck}
                                        disabled={subtitleOnlyMap[data.dbid] || false}
                                      />
                                    }
                                    label="Face"
                                    labelPlacement="top"
                                    onClick={(e) => {
                                      if (subtitleOnlyMap[data.dbid] || false) {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        return;
                                      }
                                      handleFaceCheck(data.id);
                                    }}
                                    sx={{
                                      opacity: (subtitleOnlyMap[data.dbid] || false) ? 0.5 : 1,
                                      pointerEvents: (subtitleOnlyMap[data.dbid] || false) ? 'none' : 'auto'
                                    }}
                                  />
                                </Grid>

                                <Grid item xs={2} marginTop={1.5}>
                                  <Grid container direction="column" spacing={1}>
                                    <Grid item>
                                        <Select
                                          value={data.originalAudioEmotion}
                                          onChange={(e) =>
                                            handleDialogueEmotion(e, data.id)
                                          }
                                          disabled={subtitleOnlyMap[data.dbid] || false}
                                        >
                                          <MenuItem value="neutral">Neutral</MenuItem>
                                          <MenuItem value="happy">Happy</MenuItem>
                                          <MenuItem value="sad">Sad</MenuItem>
                                          <MenuItem value="angry">Angry</MenuItem>
                                          <MenuItem value="afraid">Afraid</MenuItem>
                                        </Select>
                                    </Grid>
                                    {!character?.projectId && (
                                      <Grid item>
                                        {/* For regular characters, show the dropdown (disabled for subtitle only) */}
                                        <Select
                                          value={normalizeOriginalAudioRating(
                                            data.originalAudioRating
                                          )}
                                          onChange={(e) => handleDialogueRating(e, data.id)}
                                          disabled={subtitleOnlyMap[data.dbid] || false}
                                          displayEmpty
                                          renderValue={(value) =>
                                            value ? `${value} 𖤐` : ""
                                          }
                                        >
                                          <MenuItem value="">
                                            <em>No Rating</em>
                                          </MenuItem>
                                          <MenuItem value="1">1 𖤐</MenuItem>
                                          <MenuItem value="2">2 𖤐</MenuItem>
                                          <MenuItem value="3">3 𖤐</MenuItem>
                                          <MenuItem value="4">4 𖤐</MenuItem>
                                          <MenuItem value="5">5 𖤐</MenuItem>
                                        </Select>
                                      </Grid>
                                    )}
                                  </Grid>
                                </Grid>
                                <Grid item xs={0.8} justifyContent="center">
                                  <Grid
                                    item
                                    sx={{
                                      cursor: (subtitleOnlyMap[data.dbid] || false) ? "default" : "pointer",
                                      color: (subtitleOnlyMap[data.dbid] || false) ? "gray" : secondaryColor,
                                      "&:hover": {
                                        color: (subtitleOnlyMap[data.dbid] || false) ? "gray" : primaryColor,
                                      },
                                      opacity: (subtitleOnlyMap[data.dbid] || false) ? 0.5 : 1
                                    }}
                                  >
                                    <AddCircleIcon
                                      onClick={() => {
                                        if (subtitleOnlyMap[data.dbid] || false) return;
                                        const updatedData = [...audioData];
                                        updatedData[data.id] = {
                                          ...updatedData[data.id],
                                          add: true,
                                        };

                                        setAudioData(updatedData);
                                      }}
                                      fontSize="large"
                                    />
                                  </Grid>
                                  <Grid
                                    item
                                    fontSize="var(--font-size-header)"
                                    sx={{ cursor: "pointer", color: "red" }}
                                  >
                                    <DeleteIcon
                                      onClick={() => removeDialogue(data.dbid)}
                                      fontSize="large"
                                    />
                                  </Grid>
                                </Grid>
                                <Grid item xs={0.1} marginTop={2.5}>
                                  <Grid
                                    item
                                    sx={{
                                      cursor: (subtitleOnlyMap[data.dbid] || false) ? "default" : "pointer",
                                      color: (subtitleOnlyMap[data.dbid] || false) ? "gray" : "#353234",
                                      opacity: (subtitleOnlyMap[data.dbid] || false) ? 0.5 : 1
                                    }}
                                  >
                                  <Tooltip title="Click this button to merge this dialogue with the next one.">
                                    <img
                                      src={joinBelow}
                                      alt=""
                                      width="32px"
                                      height="32px"
                                      onClick={(e) => {
                                        if (subtitleOnlyMap[data.dbid] || false) {
                                          e.preventDefault();
                                            return;
                                          }
                                          MergeDialogues(data.id);
                                        }}
                                        style={{
                                          opacity: (subtitleOnlyMap[data.dbid] || false) ? 0.5 : 1,
                                          pointerEvents: (subtitleOnlyMap[data.dbid] || false) ? "none" : "auto"
                                        }}
                                      />
                                    </Tooltip>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                            {data.add ? (
                              <Grid
                                item
                                container
                                direction="row"
                                marginLeft={3.1}
                                gap={5}
                              >
                                <Grid
                                  item
                                  container
                                  direction="column"
                                  xs={1}
                                  // justifyContent="center"
                                  marginTop={1.1}
                                  className={classes["AudioWorkPlaceTimeline"]}
                                >
                                  <Grid color="blue" item marginBottom={1}>
                                    <textarea
                                      className={
                                        classes["AudioWorkPlaceTimelineEditInput"]
                                      }
                                      value={startTimeText}
                                      type="text"
                                      onChange={(e) =>
                                        setStartTimeText(e.target.value)
                                      }
                                    ></textarea>
                                  </Grid>
                                  <Grid item color="blue">
                                    <textarea
                                      className={
                                        classes["AudioWorkPlaceTimelineEditInput"]
                                      }
                                      value={endTimeText}
                                      type="text"
                                      onChange={(e) =>
                                        setEndTimeText(e.target.value)
                                      }
                                    ></textarea>
                                  </Grid>
                                </Grid>
                                <Grid
                                  item
                                  container
                                  className={classes["AudioWorkPlaceBoxes"]}
                                  direction="column"
                                  gap={1}
                                  paddingLeft={2}
                                  paddingTop={1}
                                  xs={5}
                                  marginRight={1}
                                >
                                  <Grid item container alignContent="center">
                                    {speakerText ? (
                                      <>
                                        {/* <Grid item marginRight={2} xs={1}>
                               
                                      </Grid> */}

                                        <Grid
                                          width="200px"
                                          height="22px"
                                          marginBottom={0.5}
                                        >
                                          <Select
                                            value={speakerText}
                                            onChange={(e) =>
                                              setSpeakerText(e.target.value)
                                            }
                                            input={<BootstrapInputForAvalialbe />}
                                          >
                                            {sortedCharacters.map((char) => (
                                              <MenuItem
                                                key={char.speaker}
                                                value={char.speaker}
                                              >
                                                {findDisplayName(char.speaker)}
                                              </MenuItem>
                                            ))}
                                          </Select>
                                        </Grid>
                                      </>
                                    ) : (
                                      <>
                                        <Grid
                                          width="100px"
                                          height="22px"
                                          marginBottom={0}
                                          item
                                          marginRight={2}
                                          xs={1}
                                        >
                                          <Select
                                            value={speakerText}
                                            onChange={(e) =>
                                              setSpeakerText(e.target.value)
                                            }
                                            input={<BootstrapInput />}
                                          >
                                            {sortedCharacters.map((char) => (
                                              <MenuItem
                                                key={char.speaker}
                                                value={char.speaker}
                                              >
                                                {findDisplayName(char.speaker)}
                                              </MenuItem>
                                            ))}
                                          </Select>
                                        </Grid>
                                      </>
                                    )}
                                  </Grid>
                                  <Grid item>
                                    <textarea
                                      style={{ height: "30px" }}
                                      className={
                                        classes["AudioWorkTextEditInput"]
                                      }
                                      value={diaText}
                                      placeholder="write here"
                                      type="text"
                                      onChange={(e) => setDiaText(e.target.value)}
                                    ></textarea>
                                  </Grid>
                                  <Grid marginTop={1.5}>
                                    <Select
                                      value={audioEmotion}
                                      onChange={(e) =>
                                        setAudioEmotion(e.target.value)
                                      }
                                    >
                                      <MenuItem value="neutral">Neutral</MenuItem>
                                      <MenuItem value="happy">Happy</MenuItem>
                                      <MenuItem value="sad">Sad</MenuItem>
                                      <MenuItem value="angry">Angry</MenuItem>
                                      <MenuItem value="afraid">Afraid</MenuItem>
                                    </Select>
                                  </Grid>
                                  <Grid marginTop={1.5}>
                                    <Select
                                      value={audioRating}
                                      onChange={(e) =>
                                        setAudioRating(e.target.value)
                                      }
                                      displayEmpty
                                      renderValue={(value) =>
                                        value ? `${value} 𖤐` : ""
                                      }
                                    >
                                      <MenuItem value="">
                                        <em>No Rating</em>
                                      </MenuItem>
                                      <MenuItem value="1">1 𖤐 </MenuItem>
                                      <MenuItem value="2">2 𖤐 </MenuItem>
                                      <MenuItem value="3">3 𖤐 </MenuItem>
                                      <MenuItem value="4">4 𖤐 </MenuItem>
                                      <MenuItem value="5">5 𖤐 </MenuItem>
                                    </Select>
                                  </Grid>
                                  <Grid item alignContent="center">
                                    <Grid
                                      item
                                      onClick={() => {
                                        AddNewDialogue(data.id);
                                      }}
                                      sx={{
                                        cursor: "pointer",
                                        color: `${secondaryColor}`,
                                        "&:hover": {
                                          color: `${primaryColor}`,
                                        },
                                      }}
                                    >
                                      <SaveIcon fontSize="large" />
                                    </Grid>
                                    <Grid
                                      item
                                      fontSize="var(--font-size-header)"
                                      sx={{
                                        cursor: "pointer",
                                        color: "red",
                                      }}
                                    >
                                      <CancelIcon
                                        onClick={() => {
                                          const updatedData = [...audioData];
                                          updatedData[data.id] = {
                                            ...updatedData[data.id],
                                            add: false,
                                          };
                                          setAudioData(updatedData);
                                        }}
                                        fontSize="large"
                                      />
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            ) : (
                              <></>
                            )}
                          </React.Fragment>
                        )
                      })}
                    </>
                  ) : (
                    <>
                      <SoundEffectsParts
                        setSeekTime={setSeekTime}
                        seekTimeIndex={seekTimeIndex}
                        setSeekTimeIndex={setSeekTimeIndex}
                        currentTime={currentTime}
                      />
                    </>
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              container
              alignItems="center"
              justifyContent="center"
              marginTop={1}
            >
              {workPlaceType ? (
                <Grid
                  item
                  container
                  alignItems="center"
                  justifyContent="center"
                  gap={1}
                  flexWrap="wrap"
                >
                  <Grid item>
                    <TaskButton
                      onClick={() => nextPrevPageAPI("previous")}
                      disabled={
                        Number(pageNumber) === 1 || pageButtonActivity || totalPages === 0
                      }
                      width="80px"
                    >
                      Previous
                    </TaskButton>
                  </Grid>

                  <Grid item>
                    <input
                      type="text"
                      style={{ width: "50px", textAlign: "center" }}
                      value={pageInput}
                      onChange={handlePageInputChange}
                      onKeyDown={handlePageInputKeyDown}
                      onBlur={() => {
                        if (pageInput === "") {
                          setPageInput(String(pageNumber));
                        }
                      }}
                      aria-label="Page number"
                    />
                  </Grid>

                  <Grid item>
                    <span>of {totalPages}</span>
                  </Grid>

                  <Grid item>
                    <TaskButton
                      width="80px"
                      onClick={() => nextPrevPageAPI("next")}
                      disabled={
                        Number(pageNumber) === totalPages ||
                        pageButtonActivity ||
                        totalPages === 0
                      }
                    >
                      Next
                    </TaskButton>
                  </Grid>
                </Grid>
              ) : (
                <></>
              )}
              <Grid item></Grid>
            </Grid>
          </Box>

          <UnifiedVideoPlayer
            source={videoSource}
            audioSource={audioSource}
            seekTime={seekTime}
            displayAudioTime={displayAudioTime}
            seekTimeIndex={seekTimeIndex}
            setPausePlay={setPausePlay}
            layout="vertical"
            dualAudio={true}
            showDebug={true}
            customClasses={{
              videoContainer: classes["AudioOutputVideo"],
              controlsContainer: classes["AudioOutputController"],
              timeDisplay: classes["AudioOutputShownTime"],
              selector: classes["AudioOutputShowTimeOptionBox"],
            }}
            onTimeSync={handleTimeSync}
          />

          <Grid
            item
            container
            xs={12}
            direction="column"
            marginTop={4}
            rowGap={2}
          >
            <Grid
              item
              sx={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <TaskButton
                onClick={() => finalSubmission()}
                disabled={loading || isConfirmationOpen}
                style={{
                  background:
                    loading || isConfirmationOpen ? "grey" : undefined,
                  marginBottom: "8px",
                }}
                className={classes["AudioWorkPlaceButton"]}
              >
                Submit All
              </TaskButton>
            </Grid>
            <Grid item>
              {characterProgressEntries.length === 0 ? (
                statsLoading ? (
                  <Typography variant="body2">
                    Loading character readiness...
                  </Typography>
                ) : (
                  <Typography variant="body2">
                    No character readiness data is available yet.
                  </Typography>
                )
              ) : (
                <Box
                    sx={{
                        position: "relative",
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    <TableContainer
                        component={Paper}
                        sx={{
                            width: "100%",
                            maxWidth: "100%",
                            overflowX: "hidden",
                            borderRadius: "var(--radius-md)",
                            opacity: statsLoading ? 0.5 : 1,
                            transition: "opacity 0.2s ease-in-out",
                        }}
                    >
                        <Table
                            size="small"
                            stickyHeader
                            sx={{
                                width: "100%",
                                tableLayout: "fixed",
                            }}
                        >
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        colSpan={4}
                                        className={classes["AudioTitles"]}
                                        sx={{
                                            p: 0,
                                            borderBottom: statsExpanded ? undefined : "none",
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                padding: "12px 20px",
                                                flexWrap: "wrap",
                                                gap: 1.5,
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 2,
                                                }}
                                            >
                                                <Typography
                                                    component="span"
                                                    className={classes["AudioTitleFont"]}
                                                    sx={{
                                                        color: "inherit",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 1,
                                                    }}
                                                >
                                                    <QueryStatsIcon fontSize="medium" />
                                                    Character Readiness
                                                </Typography>
                                            </Box>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 1,
                                                }}
                                            >
                                                {tableStatusLevel && (
                                                    <Box
                                                        component="span"
                                                        sx={{
                                                            width: 12,
                                                            height: 12,
                                                            borderRadius: "50%",
                                                            backgroundColor:
                                                                statusColorMap[tableStatusLevel],
                                                        }}
                                                        aria-hidden="true"
                                                    />
                                                )}
                                                <IconButton
                                                    size="small"
                                                    onClick={() => setStatsExpanded((prev) => !prev)}
                                                    aria-label={
                                                        statsExpanded
                                                            ? "Collapse character readiness"
                                                            : "Expand character readiness"
                                                    }
                                                    sx={{
                                                        color: "var(--color-table-header-text)",
                                                        backgroundColor: "rgba(255, 255, 255, 0.08)",
                                                        "&:hover": {
                                                            backgroundColor: "rgba(255, 255, 255, 0.16)",
                                                        },
                                                    }}
                                                >
                                                    {statsExpanded ? (
                                                        <KeyboardArrowUpIcon fontSize="small" />
                                                    ) : (
                                                        <KeyboardArrowDownIcon fontSize="small" />
                                                    )}
                                                </IconButton>
                                            </Box>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                                {statsExpanded && (
                                    <TableRow>
                                        <TableCell sx={{ fontWeight: "bold", width: "25%" }}>
                                            Character
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: "bold", width: "25%" }}>
                                            Ratings
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: "bold", width: "25%" }}>
                                            Emotions
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: "bold", width: "25%", p: 1 }}>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                    gap: 1,
                                                    width: "100%",
                                                }}
                                            >
                                                <Typography
                                                    component="span"
                                                    sx={{
                                                        fontWeight: "bold",
                                                        color: "white",
                                                    }}
                                                >
                                                    Voices
                                                </Typography>

                                                <TaskButton
                                                    onClick={() => evaluateAllVoices()}
                                                    disabled={loading || isConfirmationOpen}
                                                    style={{
                                                        background: loading || isConfirmationOpen ? "grey" : undefined,
                                                        marginBottom: 0,
                                                        minWidth: "80px",
                                                        height: "28px",
                                                        padding: "2px 10px",
                                                    }}
                                                    className={classes["AudioWorkPlaceButton"]}
                                                >
                                                    Evaluate
                                                </TaskButton>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableHead>
                            <TableBody>
                                {statsExpanded &&
                                    characterProgressEntries.map((entry) => (
                                        <TableRow key={entry.speaker}>
                                            <TableCell>
                                                <Stack spacing={0.25}>
                                                    <Typography
                                                        variant="body2"
                                                        sx={{ fontWeight: 600 }}
                                                    >
                                                        {entry.displayName}
                                                    </Typography>
                                                    <Typography
                                                        variant="caption"
                                                        sx={{ color: "text.secondary" }}
                                                    >
                                                        {`Dialogue Entries: ${entry.dialogueCount}`}
                                                    </Typography>
                                                </Stack>
                                            </TableCell>
                                            <TableCell>
                                                {entry.isImportedVoice ? (
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            minHeight: "100%",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                                            Imported Voice
                                                        </Typography>
                                                    </Box>
                                                ) : (
                                                    <Stack spacing={0.5} sx={{ width: "100%" }}>
                                                        {ratingSummaryRows.map((row) => {
                                                            const ratingTotal = row.isUnrated
                                                                ? entry.unratedCount
                                                                : row.ratingValues.reduce(
                                                                      (total, ratingValue) =>
                                                                          total +
                                                                          (entry.ratingCounts[ratingValue] ?? 0),
                                                                      0
                                                                  );

                                                            return (
                                                                <Box
                                                                    key={`${entry.speaker}-rating-${row.key}`}
                                                                    sx={{
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        alignItems: "center",
                                                                        gap: 1,
                                                                    }}
                                                                >
                                                                    <Typography
                                                                        variant="body2"
                                                                        sx={{ color: "text.secondary" }}
                                                                    >
                                                                        {row.label}
                                                                    </Typography>
                                                                    <Typography
                                                                        variant="body2"
                                                                        sx={{ fontWeight: 600 }}
                                                                    >
                                                                        {ratingTotal}
                                                                    </Typography>
                                                                </Box>
                                                            );
                                                        })}
                                                    </Stack>
                                                )}
                                            </TableCell>
                                            <TableCell>
                                                {entry.isImportedVoice ? (
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            minHeight: "100%",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                                            Imported Voice
                                                        </Typography>
                                                    </Box>
                                                ) : (
                                                    <Stack spacing={0.5} sx={{ width: "100%" }}>
                                                        {emotionKeys.map((emotion) => {
                                                            const emotionStats =
                                                                entry.emotionCounts[emotion] ?? {
                                                                    total: 0,
                                                                    highRated: 0,
                                                                };
                                                            const readableEmotion = emotion.replace(/_/g, " ");
                                                            const highRatedCount =
                                                                emotionStats.highRated ?? 0;
                                                            const totalEmotionCount =
                                                                emotionStats.total ?? 0;
                                                            const {
                                                                level: emotionStatusLevel,
                                                                label: emotionStatusLabel,
                                                            } = getReadinessStatus(highRatedCount);

                                                            return (
                                                                <Box
                                                                    key={`${entry.speaker}-emotion-${emotion}`}
                                                                    sx={{
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        alignItems: "center",
                                                                        gap: 1,
                                                                    }}
                                                                >
                                                                    <Typography
                                                                        variant="body2"
                                                                        sx={{
                                                                            color: "text.secondary",
                                                                            textTransform: "capitalize",
                                                                        }}
                                                                    >
                                                                        {readableEmotion}
                                                                    </Typography>
                                                                    <Box
                                                                        sx={{
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            gap: 1,
                                                                        }}
                                                                    >
                                                                        <Typography
                                                                            variant="body2"
                                                                            sx={{ fontWeight: 600 }}
                                                                        >
                                                                            {`${highRatedCount} (${totalEmotionCount})`}
                                                                        </Typography>
                                                                        <Box
                                                                            component="span"
                                                                            sx={{
                                                                                width: 10,
                                                                                height: 10,
                                                                                borderRadius: "50%",
                                                                                backgroundColor:
                                                                                    statusColorMap[emotionStatusLevel] ||
                                                                                    "#bdbdbd",
                                                                            }}
                                                                            aria-hidden="true"
                                                                        />
                                                                        <Typography
                                                                            variant="body2"
                                                                            sx={{ fontWeight: 600 }}
                                                                        >
                                                                            {emotionStatusLabel}
                                                                        </Typography>
                                                                    </Box>
                                                                </Box>
                                                            );
                                                        })}
                                                    </Stack>
                                                )}
                                            </TableCell>
                                            <TableCell>
                                                <Stack spacing={0.5} sx={{ width: "100%" }}>
                                                    {emotionKeys.map((emotion) => {
                                                        const readableEmotion = emotion.replace(/_/g, " ");
                                                        const voiceStatus = getCharacterEmotionVoiceStatus(
                                                            entry.speaker,
                                                            emotion
                                                        );

                                                        const isCensored = voiceStatus === "censored";
                                                        const isAvailable = voiceStatus === "available";
                                                        const isNotTrained = voiceStatus === "not_trained";

                                                        return (
                                                            <Box
                                                                key={`${entry.speaker}-voice-${emotion}`}
                                                                sx={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    alignItems: "center",
                                                                    gap: 1,
                                                                }}
                                                            >
                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                        color: "text.secondary",
                                                                        textTransform: "capitalize",
                                                                    }}
                                                                >
                                                                    {readableEmotion}
                                                                </Typography>

                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                        fontWeight: 700,
                                                                        color: isCensored
                                                                            ? "warning.main"
                                                                            : isAvailable
                                                                              ? "success.main"
                                                                              : isNotTrained
                                                                                ? "text.secondary"
                                                                                : "text.secondary",
                                                                    }}
                                                                >
                                                                    {voiceStatus}
                                                                </Typography>
                                                            </Box>
                                                        );
                                                    })}
                                                </Stack>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {statsLoading && statsExpanded && (
                        <Box
                            sx={{
                                position: "absolute",
                                inset: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                pointerEvents: "none",
                                backgroundColor: "rgba(255, 255, 255, 0.5)",
                            }}
                        >
                            <CircularProgress size={32} />
                        </Box>
                    )}
                </Box>
              )}
            </Grid>
          </Grid>

          <Grid
            item
            container
            xs={12}
            direction="row"
            alignContent="center"
            justifyContent="flex-end"
            marginTop={2}
          ></Grid>
          <Grid
            item
            container
            xs={11.8}
            direction="row"
            alignContent="center"
            justifyContent="flex-end"
            marginTop={2}
            paddingBottom={3}
            gap={5}
          ></Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default TranscriberScreen;
